import { render, staticRenderFns } from "./BaseBox.vue?vue&type=template&id=a3f66034&scoped=true"
import script from "./BaseBox.vue?vue&type=script&lang=js"
export * from "./BaseBox.vue?vue&type=script&lang=js"
import style0 from "./BaseBox.vue?vue&type=style&index=0&id=a3f66034&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f66034",
  null
  
)

export default component.exports